import React, { Component } from 'react';

import 'css/components/subdomain/admin/_AdminSidebarSectionItem.scss';

export default class AdminSidebarSectionItem extends Component {
  render() {
    return <div className="adminSidebarSectionItem">{this.props.children}</div>;
  }
}
